import { render } from "./AccountEditPage.vue?vue&type=template&id=8101f556"
import script from "./AccountEditPage.vue?vue&type=script&lang=js"
export * from "./AccountEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__